//Custom WishList Function
var wishListsArr = localStorage.getItem('items') ? JSON.parse(localStorage.getItem('items')) : [];

localStorage.setItem('items', JSON.stringify(wishListsArr));

if (wishListsArr.length) {
  wishListsArr = JSON.parse(localStorage.getItem('items'));
};
 
if($('body').hasClass('template-page') && $('.wish-list').length) {
  initWishLists();
};

initWishListIcons();
doAddOrRemoveWishlish();
createWishListTplItem();

function createWishListTplItem (ProductHandle) {
  var wishListCotainer = $('[data-wishlist-container]');

  jQuery.getJSON('/products/'+ProductHandle+'.js', function(product) {
      var productHTML = '',
          price_min = Shopify.formatMoney(product.price_min, window.money_format);

      productHTML += '<div class="grid-item" data-wishlist-added="wishlist-'+product.id+'">';
      productHTML += '<div class="inner product-item" data-product-id="product-'+product.handle+'">';
      productHTML += '<div class="column col-img"><div class="product-image">';
      productHTML +='<a href="'+product.url+'" class="product-grid-image" data-collections-related="/collections/all?view=related">';
      if (product.featured_image) {
          productHTML += '<img src="'+product.featured_image+'" alt="'+product.featured_image.alt+'">';
      }
      productHTML += '</a></div></div>';
      productHTML += '<div class="column col-prod">';
      productHTML += '<a class="product-title" href="'+product.url+'" title="'+product.title+'">'+product.title+'</a>';
      productHTML += '<div class="product-vendor">';
      productHTML += '<a href="' + window.router + '/collections/vendors?q='+product.vendor+'" title="'+product.vendor+'">'+product.vendor+'</a></div></div>';
      productHTML += '<div class="column col-price text-center"><div class="price-box">'+ price_min +'</div></div>';
      productHTML += '<div class="column col-options text-center">';
      productHTML += '<form action="/cart/add" method="post" class="variants" id="wishlist-product-form-' + product.id +'" data-id="product-actions-'+product.id+'" enctype="multipart/form-data">';

      if (product.available) {
              productHTML += '<a class="btn" title="'+product.title+'" href="' + product.url +'">'+window.inventory_text.add_to_cart+'</a>';
          // if (product.variants.length == 1) {
          //     productHTML += '<button data-btn-addToCart class="btn add-to-cart-btn" data-form-id="#wishlist-product-form-' + product.id +'" type="submit">'+window.inventory_text.add_to_cart+'</button><input type="hidden" name="id" value="'+ product.variants[0].id +'" />';
          // }
          // if (product.variants.length > 1){
          //     productHTML += '<a class="btn" title="'+product.title+'" href="' + product.url +'">'+window.inventory_text.select_options+'</a>';
          // }
      } else {
          productHTML += '<button class="btn add-to-cart-btn" type="submit" disabled="disabled">'+window.inventory_text.unavailable+'</button>';
      }

      productHTML += '</form></div>';
      productHTML += '<div class="column col-remove text-center"><a class="whislist-added" href="#" data-product-handle="'+ product.handle +'" data-icon-wishlist data-id="'+ product.id +'"><svg class="closemnu" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 357 357" xml:space="preserve"><g><g><polygon points="357,35.7 321.3,0 178.5,142.8 35.7,0 0,35.7 142.8,178.5 0,321.3 35.7,357 178.5,214.2 321.3,357 357,321.3 214.2,178.5"></polygon></g></g></svg></a></div>';
      productHTML += '</div></div>';

      wishListCotainer.append(productHTML);
      var regex = /(<([^>]+)>)/ig;
      var href = $('.wrapper-wishlist a.share').attr("href");
      href += encodeURIComponent( product.title + '\nPrice: ' + price_min.replace(regex, "") + '\nLink: ' + window.location.protocol + '//' + window.location.hostname + product.url +'\n\n');
      $('.wrapper-wishlist a.share').attr("href", href );
  });
}

function initWishListPagging () {
  var data = JSON.parse(localStorage.getItem('items'));

    var wlpaggingContainer = $('#wishlist-paginate');
    var paggingTpl = '<li class="text disabled prev"><a href="#" title="'+window.inventory_text.previous+'"><i class="fa fa-angle-left" aria-hidden="true"></i><span>'+window.inventory_text.previous+'</span></a></li>';
    var wishListCotainer = $('[data-wishlist-container]');

    wlpaggingContainer.children().remove();

    var totalPages = Math.ceil(data.length / 3);

    if (totalPages <= 1) {
        wishListCotainer.children().show();
        return;
    }

    for (var i = 0; i < totalPages; i++) {
        var pageNum = i + 1;
        if (i === 0) paggingTpl += '<li class="active"><a data-page="' + pageNum + '" href="'+ pageNum +'" title="'+ pageNum +'">' + pageNum + '</a></li>'
        else paggingTpl += '<li><a data-page="' + pageNum + '" href="'+ pageNum +'" title="'+ pageNum +'">' + pageNum + '</a></li>'
    }

    paggingTpl += '<li class="text next"><a href="#" title="'+window.inventory_text.next+'"><span>'+window.inventory_text.next+'</span><i class="fa fa-angle-right" aria-hidden="true"></i></a></li>';

    wlpaggingContainer.append(paggingTpl);

    wishListCotainer.children().each(function(idx, elm) {
        if (idx >= 0 && idx < 3) {
            $(elm).show();
        }
        else {
            $(elm).hide();
        }
    });

    wlpaggingContainer.off('click.wl-pagging').on('click.wl-pagging', 'li a', function(e) {
        e.preventDefault();

        var isPrev = $(this).parent().hasClass('prev');
        var isNext = $(this).parent().hasClass('next');
        var pageNumber = $(this).data('page');

        if (isPrev) {
            var curPage = parseInt($(this).parent().siblings('.active').children().data('page'));
            pageNumber = curPage - 1;
        }

        if (isNext) {
            var curPage = parseInt($(this).parent().siblings('.active').children().data('page'));
            pageNumber = curPage + 1;
        }

        wishListCotainer.children().each(function(idx, elm) {
            if (idx >= (pageNumber - 1) * 3 && idx < pageNumber * 3) {
                $(elm).show();
            }
            else {
                $(elm).hide();
            }
        });

        if (pageNumber === 1) {
            wlpaggingContainer.find('.prev').addClass('disabled');
            wlpaggingContainer.find('.next').removeClass('disabled');
        }
        else if (pageNumber === totalPages) {
            wlpaggingContainer.find('.next').addClass('disabled');
            wlpaggingContainer.find('.prev').removeClass('disabled');
        }
        else {
            wlpaggingContainer.find('.prev').removeClass('disabled');
            wlpaggingContainer.find('.next').removeClass('disabled');
        }

        $(this).parent().siblings('.active').removeClass('active');
        wlpaggingContainer.find('[data-page="' + pageNumber + '"]').parent().addClass('active');

    });
}

function initWishLists () {
    if (typeof(Storage) !== 'undefined') {
      var data = JSON.parse(localStorage.getItem('items'));

      if (data.length <= 0) {
          return;
      }

      data.forEach(function(item) {
          createWishListTplItem(item);
      });

      initWishListPagging();
      // this.translateBlock('.wishlist-page');

  } else {
      alert('Sorry! No web storage support..');
  }
}

function setAddedForWishlistIcon (ProductHandle) {
    var wishlistElm = $('[data-product-handle="'+ ProductHandle +'"]'),
        idxArr = wishListsArr.indexOf(ProductHandle);

    var wishListCountNum = $('[data-wishlist-count]');
    var totalProductWs = Math.ceil(wishListsArr.length );
    wishListCountNum.text(totalProductWs);

    if(idxArr >= 0) {
        wishlistElm.addClass('whislist-added');
        if($('.style_product_grid_3').length) {
            wishlistElm.find('.wishlist-text').text(window.inventory_text.remove_wishlist_1); 
        } else {
            wishlistElm.find('.wishlist-text').text(window.inventory_text.remove_wishlist); 
        }
    }
    else {
        wishlistElm.removeClass('whislist-added');
        if($('.style_product_grid_3').length) {
            wishlistElm.find('.wishlist-text').text(window.inventory_text.add_wishlist_1);
        } else {
            wishlistElm.find('.wishlist-text').text(window.inventory_text.add_wishlist);
        }
    };
}

function doAddOrRemoveWishlish () {
  var iconWishListsSlt = '[data-icon-wishlist]';
  var wishListCountNum = $('[data-wishlist-count]');
  var totalProductWs = Math.ceil(wishListsArr.length);
  wishListCountNum.text(totalProductWs);
  
  $(document).off('click.addOrRemoveWishlist', iconWishListsSlt).on('click.addOrRemoveWishlist', iconWishListsSlt, function(e) {
      var self = $(this),
          productId = self.data('id'),
          ProductHandle = self.data('product-handle'),
          idxArr = wishListsArr.indexOf(ProductHandle);

      if(!self.hasClass('whislist-added')) {
          self.addClass('whislist-added');
          if($('.style_product_grid_3').length) {
              self.find('.wishlist-text').text(window.inventory_text.remove_wishlist_1);
          } else {
              self.find('.wishlist-text').text(window.inventory_text.remove_wishlist);
          }

          if($('[data-wishlist-container]').length) {
              createWishListTplItem(ProductHandle);
          };

          wishListsArr.push(ProductHandle);
          localStorage.setItem('items', JSON.stringify(wishListsArr));
      } else {
          self.removeClass('whislist-added');
          if($('.style_product_grid_3').length) {
              self.find('.wishlist-text').text(window.inventory_text.add_wishlist_1);
          } else {
              self.find('.wishlist-text').text(window.inventory_text.add_wishlist);
          }
          
          if($('[data-wishlist-added="wishlist-'+productId+'"]').length) {
              $('[data-wishlist-added="wishlist-'+productId+'"]').remove();
          }

          wishListsArr.splice(idxArr, 1);
          localStorage.setItem('items', JSON.stringify(wishListsArr));

          if($('[data-wishlist-container]').length) {
              initWishListPagging();
          };
      };

      setAddedForWishlistIcon(ProductHandle);
    });
}

function initWishListIcons () {
  var wishListItems = localStorage.getItem('items') ? JSON.parse(localStorage.getItem('items')) : [];
  var wishListCountNum = $('[data-wishlist-count]');
  var totalProductWs = Math.ceil(wishListsArr.length);
  wishListCountNum.text(totalProductWs);

  if (!wishListItems.length) {
      return;
  }

  for (var i = 0; i < wishListItems.length; i++) {
      var icon = $('[data-product-handle="'+ wishListItems[i] +'"]');
      icon.addClass('whislist-added');

      if($('.style_product_grid_3').length) {
          icon.find('.wishlist-text').text(window.inventory_text.remove_wishlist_1);
      } else {
          icon.find('.wishlist-text').text(window.inventory_text.remove_wishlist);
      } 


  };
}
//End Custom WishList Function